import { atom } from "jotai";

export const intentTableScrollToIntentIdAtom = atom<string | undefined>();
